import { render } from "./irrigationValve.vue?vue&type=template&id=0371937c&scoped=true"
import script from "./irrigationValve.vue?vue&type=script&lang=js"
export * from "./irrigationValve.vue?vue&type=script&lang=js"

import "./irrigationValve.vue?vue&type=style&index=0&id=0371937c&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\horva\\Documents\\nodejs\\production\\enat05\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0371937c"]])

export default __exports__